import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=0ddc8df4&"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports